'use client'

import { useReportErrorOnce } from '@repo/analytics/sentry/react'
import { ErrorPage } from '@repo/features/error'

export default function GlobalError(props: {
  error: Error & { digest?: string }
  reset: () => void
}) {
  useReportErrorOnce(props.error)

  return (
    <html data-sentry-component="GlobalError" data-sentry-source-file="global-error.tsx">
      <body>
        <ErrorPage {...props} data-sentry-element="ErrorPage" data-sentry-source-file="global-error.tsx" />
      </body>
    </html>
  )
}
